// Copyright 2020 Drivetrain Hub LLC
// PLACEHOLDER {performance} reduce app size with on-demand imports
// https://element.eleme.io/#/en-US/component/quickstart#on-demand

import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'  // default Element UI styling
import DlgDraggable from './assets/js/dlg_draggable';
import SvgIcon from 'vue-svgicon';
import DhIcon from './components/_icons/DhIcon';
import {store} from './store';
import {router} from './config/router';
import {apolloProvider} from './config/apollo';
import {graphql} from "./config/apollo";
import Urls from './config/urls';
import Tabs from "./config/tabs";
import Icons from './config/icons';
import Defaults from './config/defaults';
import Requests from "./requests";
import Handlers from "./handlers";

// CONFIG
Vue.use(ElementUI, {locale});
Vue.use(DlgDraggable);
Vue.use(Urls);
Vue.use(Tabs);
Vue.use(Icons);
Vue.use(Defaults);
Vue.use(Requests);
Vue.use(Handlers);
Vue.use(graphql);
Vue.use(SvgIcon);  // default tagName: svgicon
Vue.config.productionTip = false;

// REGISTER GLOBAL COMPONENTS
// https://stackoverflow.com/questions/40331896/how-to-use-vuejs-2-global-components-inside-single-file-components
Vue.component('dh-icon', DhIcon);

// VUE INSTANCE ($root)
new Vue({
  store,
  router,
  apolloProvider,
  render: h => h(App),

  // global methods dependent on Vue instance (this.) and/or not dependent on state
  methods: {
    confirmCloseModel() {
      return this.$confirm('Close current model?', '', {
        showClose: false,
        showCancelButton: true,
        showConfirmButton: true,
      })
    },
    confirmNewModel() {
      this.confirmCloseModel()
        .then(() => {
          // confirmed - create a new model
          this.$store.dispatch('createModel')
            .then(modelId => {
              // open new model in modeling view
              this.$store.commit('SET_SKIP_ROUTE_CONFIRM', true);
              this.$router.push({ name: 'openModel', params: { modelId: modelId }})
            })
        })
        .catch(/*cancelled - do nothing*/);
    },
    /**
     * Delete library object upon user confirmation.
     * @param {{owner, name}} obj - Library object to delete; must include props:  owner, name
     *  Additional object props may be included but are not used.
     * @param {function} mutateDelete - Function to run after user confirmation to delete.
     *  Must return boolean to indicate if delete operation failed or succeeded.
     * @param {function} onDelete - Function to run after successful deletion.
     */
    confirmDelete({owner, name}, mutateDelete, onDelete) {
      // check if user is allowed to delete
      if (owner === this.$store.state.session.user.Id) {
        // current user is allowed to delete
        this.$confirm('Delete?  This operation cannot be undone.', name, {
          type: 'error',
          showClose: false,
          showCancelButton: true,
          showConfirmButton: true,
        }).then(async () => {
          const is_deleted = await mutateDelete();

          if (is_deleted) {
            onDelete();
            this.$notify.success({
              position: this.$defaults.notifyPosition,
              title: 'Deleted',
              message: name,
            });
          } else {
            this.$message({
              type: 'error',
              message: 'Delete operation failed!  Are you sure it still exists?',
              center: true,
            });
          }
        });
      } else {
        // PLACEHOLDER {feature} send email to owner to request deletion
        // const payload = {
        //   user: ownerId,
        //   model: {
        //     Id: modelToDelete.Id,
        //     name: modelToDelete.name,
        //     number: modelToDelete.number,
        //   }
        // };
        // this.$store.dispatch('emailRequestDeleteModel', payload)
        // this.$message({
        //   type: 'info',
        //   message: 'A request for deletion has been email to the model owner',
        //   center: true,
        // });

        // TEMP solution
        this.$message({
          type: 'warning',
          message: 'Model owner required to authorize delete',
          center: true,
        });
      }
    },
  }
}).$mount('#app');
